import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faMinusCircle} from '@fortawesome/pro-solid-svg-icons';
import {canRemoveAssetFromSavedCart} from '../enablers';
import {CART_SAVED_ACTION_LABELS} from '../locales';
import {type ISavedCart} from '../schema';
import {CART_SAVED_EVENT} from './constants';

export const cartSavedActionRemoveSelectedAssetsIcon = faMinusCircle;

/**
 * Remove selection asset from saved cart
 * @param params
 * @returns Action
 */
export const cartSavedActionRemoveSelectedAssets = (
	savedCart?: ISavedCart,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'cart-saved-remove-selected-assets',
	cb: () =>
		dispatcher.trigger(CART_SAVED_EVENT.REMOVE_SELECTED_ASSETS, savedCart),
	enableTest: () => canRemoveAssetFromSavedCart(savedCart),
	get label() {
		return CART_SAVED_ACTION_LABELS.REMOVE_SELECTED_ASSETS;
	},
	icon: cartSavedActionRemoveSelectedAssetsIcon,
	...params,
});

export default cartSavedActionRemoveSelectedAssets;
